import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fee-acceptance-modal',
  standalone: false,
  templateUrl: './fee-acceptance-modal.html',
  styleUrl: './fee-acceptance-modal.css'
})
export class FeeAcceptanceModal {
  @Input() companyName: string = '';

  accepted: boolean = false;

  constructor(private activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.dismiss();
  }

  confirm() {
    if (this.accepted) {
      this.activeModal.close(true);
    }
  }
}
